// extracted by mini-css-extract-plugin
module.exports = {"title":"Swap_title__u0gGP","button":"Swap_button__38tE7","table":"Swap_table__2uieQ","icon":"Swap_icon__LGI4b","all":"Swap_all__1IatM"};